import './Shops.css'
import ModalPage from "../ModalPage";
import sbp from '../img/sbp.png'

const Shops = ({ setModal, modal }) => {
    const closeModal = () => setModal(null)

    const getLinkKeksik = (shop) => {
        window.location.href = shop
    }

    if (modal !== 'shops') return null

    return <ModalPage onClose={closeModal} header="Покупки">
        <div className='Block'>
            <div className="BlockHeader">
              Обменники
            </div>

            {
                false &&
                <div className="ShopItem" onClick={() => getLinkKeksik("https://vk.com/club231518626")}>
                    <div className='ShopsAva'>
                        <img src="https://sun1-14.userapi.com/s/v1/ig2/zKgYfd5GB9F2AY-0mRwFCm1Pv98UURbKuCdNRdn7yXnS2_qYa8uSoCGoqzHbJRFxJLBoQyrL622Jh0QeiX_uQWq9.jpg?quality=95&crop=6,773,1173,1173&as=32x32,48x48,72x72,108x108,160x160,240x240,360x360,480x480,540x540,640x640,720x720,1080x1080&ava=1&cs=100x100" alt="ava"/>
                    </div>
                    <div className='ShopsBody'>
                        <p>Маркет FC</p>
                        <div className='ShopsBodyInfo'>
                            <img src={sbp} alt="sbp"/>
                            <p>СБП / 20 ₽ - 5 000 ₽</p>
                        </div>
                    </div>
                </div>
            }
            {
                true &&
                <div className="ShopItem" onClick={() => getLinkKeksik("https://vk.com/joker_store_fc")}>
                    <div className='ShopsAva'>
                        <img src="https://sun9-63.userapi.com/impg/hABzsmtW4diLf3Hi9acPmxiu1nTeKgp59dN7uA/SRHxwJlZGzM.jpg?size=1280x1280&quality=95&sign=327b5fd715d75ec1ef5c45cb58a63e41&type=album" alt="ava"/>
                    </div>
                    <div className='ShopsBody'>
                        <p>JF| STORE FC</p>
                        <div className='ShopsBodyInfo'>
                            <img src={sbp} alt="sbp"/>
                            <p>СБП / 20 ₽ - 5 000 ₽</p>
                        </div>
                    </div>
                </div>
            }
            <p className='CreateShop'>
                Если хотите стать обменником напишите <a href="https://хор-енотов.рф">мне</a>.
            </p>
        </div>
    </ModalPage>
}

export default Shops